import { useEffect, useState, useCallback, useMemo } from 'react'
import { Session } from '@ory/client'
import { sdk } from '../services/sdk'
import { useNavigate } from 'react-router-dom'
import { parseJwt } from '../utils/jwt'
interface SistemivMetadataPublic {
  azure_ad_b2c_id: string
}

export const useAuth = () => {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)
  const [logoutUrl, setLogoutUrl] = useState<string>('')
  const navigate = useNavigate()

  const userId = useMemo(() => {
    // use azure_ad_b2c_id if it exists (legacy accounts), otherwise use id
    const oid = (session?.identity?.metadata_public as SistemivMetadataPublic)?.azure_ad_b2c_id
    return oid || session?.identity?.id
  }, [session])

  const createLogoutFlow = useCallback(async () => {
    try {
      const { data } = await sdk.createBrowserLogoutFlow({
        returnTo: window.location.origin,
      })
      setLogoutUrl(data.logout_url)
    } catch (error: any) {
      //can't create logout flow
    }
  }, [])

  const fetchSession = useCallback(async () => {
    try {
      setLoading(true)
      const { data: session } = await sdk.toSession({
        tokenizeAs: 'sistemiv-dev',
      })
      localStorage.setItem('access_token', session.tokenized || '')
      setSession(session)
      if (!logoutUrl) {
        createLogoutFlow()
      }
    } catch (error: any) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        navigate('/login')
      }
    } finally {
      setLoading(false)
    }
  }, [navigate, createLogoutFlow, logoutUrl])

  useEffect(() => {
    // fetch session if it's expired
    if (session) {
      const jwtExpiresAt = parseJwt(session?.tokenized || '')?.exp
      const expiresAt = new Date(jwtExpiresAt * 1000)
      const now = new Date()
      if (expiresAt < now) {
        fetchSession()
      }
    } else {
      fetchSession()
    }
  }, [navigate, createLogoutFlow, logoutUrl, session, fetchSession])

  return { isLoggedIn: !!session, session, logoutUrl, loading, fetchSession, userId }
}
